(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AppController', AppController)
 
    AppController.$inject = ["$http","GenerallabService","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AppController($http,GenerallabService,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.generalLab = GenerallabService;
    }
  
})();